var T = window.LT_T || {};
/* Ürün Detay 2 — galeri, seçili beden etiketi, Bedenimi bul */
(function () {
  /* Galeri */
  var stage = document.querySelector('[data-pd2-stage]');
  if (stage) {
    var track = stage.querySelector('[data-pd2-track]');
    var slides = track.children;
    var thumbs = stage.querySelectorAll('[data-pd2-thumb]');
    var counter = stage.querySelector('[data-pd2-current]');
    var current = 0;
    var slideW = function () { return slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth; };
    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * slideW(), behavior: 'smooth' });
    };
    var tint = function (i) {
      var img = slides[i] && slides[i].querySelector('img');
      if (!img || !img.complete || !img.naturalWidth) return;
      try {
        var c = document.createElement('canvas'); c.width = c.height = 1;
        var x = c.getContext('2d'); x.drawImage(img, 4, 4, 1, 1, 0, 0, 1, 1);
        var d = x.getImageData(0, 0, 1, 1).data;
        stage.style.setProperty('--pd2-bg', 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')');
      } catch (e) {}
    };
    var sync = function () {
      var i = Math.round(track.scrollLeft / slideW());
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = i + 1;
      stage.style.setProperty('--i', i);
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.pd2Thumb)); }); });
    stage.querySelectorAll('[data-pd2-step]').forEach(function (b) { b.addEventListener('click', function () { go(current + Number(b.dataset.pd2Step)); }); });
    var first = slides[0] && slides[0].querySelector('img');
    if (first) { first.complete ? tint(0) : first.addEventListener('load', function () { tint(0); }); }
    track.addEventListener('click', function (e) {
      var fig = e.target.closest('.pd2-stage__slide');
      if (!fig || !window.pd2Zoom) return;
      window.pd2Zoom(Number(fig.dataset.index || 0));
    });
  }

  var form = document.querySelector('.pd2-buy form');

  /* Satın alma sütunu yalnızca ekrana sığdığında yapışkan kalsın */
  var buy = document.querySelector('.pd2-buy');
  if (buy && 'ResizeObserver' in window) {
    var fit = function () {
      var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 80;
      buy.classList.toggle('is-sticky', window.innerWidth > 989 && buy.offsetHeight + top + 32 < window.innerHeight);
    };
    new ResizeObserver(fit).observe(buy);
    window.addEventListener('resize', fit);
  }

  /* Seçili seçeneği etikette göster */
  if (form) {
    var paint = function () {
      form.querySelectorAll('[data-pd2-selected]').forEach(function (b) {
        var fs = b.closest('[data-option]');
        var c = fs && fs.querySelector('input:checked');
        b.textContent = c ? c.value : '';
      });
    };
    form.addEventListener('change', paint); paint();
  }

  /* Bedenimi bul: ürün ölçüsü − vücut ölçüsü = rahatlık payı */
  var finder = document.querySelector('[data-pd2-finder]');
  if (finder && form) {
    var chart = JSON.parse(finder.querySelector('[data-pd2-chart]').textContent);
    var inputs = finder.querySelectorAll('[data-pd2-measure]');
    var out = finder.querySelector('[data-pd2-result]');
    var word = function (d) {
      if (d < 0) return [T.tight, 'is-tight'];
      if (d < 4) return [T.snug, 'is-snug'];
      if (d <= 12) return [T.good, 'is-good'];
      return [T.loose, 'is-loose'];
    };
    var calc = function () {
      var body = []; var any = false;
      inputs.forEach(function (i) { var v = parseFloat(i.value); body.push(isNaN(v) ? null : v); if (!isNaN(v)) any = true; });
      if (!any) return;
      var best = null;
      var rows = chart.sizes.map(function (size, si) {
        var ok = true;
        var cells = chart.rows.map(function (r, ri) {
          var g = parseFloat(r.values.length === 1 ? r.values[0] : r.values[si]);
          if (body[ri] === null || isNaN(g)) return '<td>–</td>';
          var d = Math.round(g - body[ri]); var w = word(d);
          if (d < 0) ok = false;
          return '<td class="' + w[1] + '">' + (d > 0 ? '+' : '') + d + ' cm<small>' + w[0] + '</small></td>';
        });
        if (ok && best === null) best = si;
        return { size: size, cells: cells };
      });
      var inStock = function (si) {
        var r = form.querySelector('[data-option] input[value="' + chart.sizes[si] + '"]');
        return r && !r.classList.contains('is-unavailable');
      };
      // Sütun adları, ziyaretçinin dilinde yazılmış giriş etiketlerinden alınır
      var lbl = function (ri) { var sp = inputs[ri] && inputs[ri].closest('label').querySelector('span'); return sp ? sp.textContent : chart.rows[ri].label; };
      var head = '<tr><th>' + T.size + '</th>' + chart.rows.map(function (r, ri) { return body[ri] === null ? '' : '<th>' + lbl(ri) + '</th>'; }).join('') + '</tr>';
      var body_rows = rows.map(function (r, si) {
        var cells = r.cells.filter(function (c, ci) { return body[ci] !== null; }).join('');
        return '<tr class="' + (si === best ? 'is-best' : '') + '"><th>' + r.size + (si === best ? ' <em>' + T.recommended + '</em>' : '') + (inStock(si) ? '' : ' <small>' + T.sold_out + '</small>') + '</th>' + cells + '</tr>';
      }).join('');
      var alt = null;
      if (best !== null && !inStock(best)) {
        for (var k = best + 1; k < chart.sizes.length; k++) { if (inStock(k)) { alt = k; break; } }
      }
      var pick = function (si) { return ' <button type="button" data-pd2-pick="' + chart.sizes[si] + '">' + (document.documentElement.lang === 'en' ? T.pick + ' ' + chart.sizes[si] : chart.sizes[si] + ' ' + T.pick) + '</button>'; };
      var msg;
      if (best === null) {
        msg = '<p class="pd2-finder__msg">' + T.none + '</p>';
      } else if (inStock(best)) {
        msg = '<p class="pd2-finder__msg">' + T.rec_a + ' <b>' + chart.sizes[best] + '</b>' + (T.rec_b === '.' ? '.' : ' ' + T.rec_b) + pick(best) + '</p>';
      } else if (alt !== null) {
        msg = '<p class="pd2-finder__msg">' + T.best_a + ' <b>' + chart.sizes[best] + '</b>' + T.best_out + ' <b>' + chart.sizes[alt] + '</b> ' + T.alt_b + pick(alt) + '</p>';
      } else {
        msg = '<p class="pd2-finder__msg">' + T.best_a + ' <b>' + chart.sizes[best] + '</b>' + T.best_out + ' ' + T.stock_wa + '</p>';
      }
      out.innerHTML = msg + '<div class="pd2-finder__table"><table>' + head + body_rows + '</table></div><p class="pd2-muted">' + T.note + '</p>';
    };
    inputs.forEach(function (i) { i.addEventListener('input', calc); });
    out.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pd2-pick]');
      if (!b) return;
      var r = form.querySelector('[data-option] input[value="' + b.dataset.pd2Pick + '"]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.closest('[data-option]').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  /* Mobil beden paneli: yapışkan çubuktaki "Beden seç" → alttan panel → bedene dokun = sepete ekle */
  var msheet = document.querySelector('[data-pd2-msheet]');
  var sticky = document.querySelector('[data-sticky-atc]');
  if (msheet && form) {
    var openSheet = function () { msheet.classList.add('is-open'); msheet.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); };
    var closeSheet = function () { msheet.classList.remove('is-open'); msheet.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };
    /* Yalnızca beden (ilk görünür seçenek) sayılır; gizli tek değerli Renk hep seçilidir */
    var selected = function () { return form.querySelector('[data-option]:not([hidden]) input:checked'); };
    if (sticky) {
      sticky.addEventListener('click', function (e) {
        if (!e.target.closest('.pd2-sticky__cta') || selected()) return;
        e.stopPropagation(); e.preventDefault();
        openSheet();
      }, true);
    }
    msheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-pd2-msheet-close]')) { closeSheet(); return; }
      var q = e.target.closest('[data-pd2-quick]');
      if (q && !q.disabled) {
        var r = form.querySelector('[data-option] input[value="' + q.dataset.pd2Quick + '"]');
        if (!r) return;
        r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
        q.classList.add('is-loading');
        closeSheet();
        var atc = form.querySelector('[data-atc]');
        if (atc && !atc.disabled) atc.click();
        setTimeout(function () { q.classList.remove('is-loading'); }, 1200);
        return;
      }
      if (e.target.closest('[data-pd2-open-finder]')) {
        closeSheet();
        var f = document.querySelector('[data-pd2-finder]');
        if (f) { f.open = true; f.scrollIntoView({ behavior: 'smooth', block: 'center' }); var i = f.querySelector('input'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 500); }
        return;
      }
      if (e.target.closest('[data-lt-size]')) closeSheet();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    var sb = sticky && sticky.querySelector('.pd2-sticky__cta');
    if (sb) {
      var label = function () { var s = selected(); sb.textContent = s ? T.add + ' · ' + s.value : T.select; };
      form.addEventListener('change', label); label();
    }
  }

  /* Yapışkan çubuk: mobilde asıl "Sepete ekle" butonu ekranda değilken; masaüstünde yalnızca buton yukarıda kalınca (aşağı kaydırınca) */
  var mainAtc = form && form.querySelector('[data-atc]');
  if (sticky && mainAtc) {
    var ticking = false;
    var place = function () {
      ticking = false;
      var r = mainAtc.getBoundingClientRect();
      var above = r.bottom < 0;
      var below = r.top > window.innerHeight;
      sticky.classList.toggle('is-shown', window.innerWidth < 990 ? (above || below) : above);
    };
    var queue = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(place); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    place();
  }
})();

/* Teslimat satırı: kesim saatine geri sayım + resmî/dinî tatilleri ve hafta sonunu atlayan tahmini teslimat aralığı.
   Saatler İstanbul saatine göre hesaplanır; metinler data-l (locales v2.pd.dl_*) içinden gelir. */
(function () {
  var el = document.querySelector('[data-pd2-deliver]');
  if (!el) return;
  var L = JSON.parse(el.dataset.l || '{}');
  var cutoff = Number(el.dataset.cutoff) || 16;
  var lang = document.documentElement.lang || 'tr';
  var HOLIDAYS = ['2026-01-01', '2026-03-19', '2026-03-20', '2026-03-21', '2026-03-22', '2026-04-23', '2026-05-01', '2026-05-19', '2026-05-26', '2026-05-27', '2026-05-28', '2026-05-29', '2026-05-30', '2026-07-15', '2026-08-30', '2026-10-29',
    '2027-01-01', '2027-03-08', '2027-03-09', '2027-03-10', '2027-03-11', '2027-04-23', '2027-05-01', '2027-05-15', '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19', '2027-07-15', '2027-08-30', '2027-10-29'];
  // İstanbul'daki takvim günü ve saati (ziyaretçinin saat diliminden bağımsız)
  var nowTR = function () {
    var p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour, m: +p.minute };
  };
  var key = function (d) { return d.toISOString().slice(0, 10); };
  var workday = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) < 0; };
  var addWork = function (d, n) { var x = new Date(d); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (workday(x)) n--; } return x; };
  var fmt = function (d, wd) { return d.toLocaleDateString(lang, { timeZone: 'UTC', day: 'numeric', month: 'long', weekday: wd ? 'long' : undefined }); };
  var render = function () {
    var n = nowTR();
    var today = workday(n.day) && n.h < cutoff;
    var ship = today ? n.day : addWork(n.day, 1);
    var a = addWork(ship, 1), b = addWork(ship, 3);
    var head;
    if (today) {
      var left = cutoff * 60 - (n.h * 60 + n.m);
      var t = (left >= 60 ? Math.floor(left / 60) + ' ' + L.h + ' ' : '') + (left % 60) + ' ' + L.m;
      head = L.today.replace('%t', t);
    } else {
      var tomorrow = new Date(n.day); tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      head = L.ship.replace('%d', key(ship) === key(tomorrow) ? L.tomorrow : fmt(ship, true));
    }
    el.innerHTML = '<span><b class="green">' + L.free + '</b> · ' + head + '<br>' + L.eta.replace('%a', fmt(a, true)).replace('%b', fmt(b, true)) + '</span>';
  };
  render();
  setInterval(render, 60000);
})();

/* Yakınlaştırma görüntüleyicisi (#Zoom): tam ekran, yan yana kaydırılan görseller.
   Mobil: iki parmakla büyüt, çift dokun = 2,5x, büyükken sürükle. Masaüstü: tıkla = büyüt, fareyle gez. */
(function () {
  var z = document.getElementById('Zoom');
  if (!z) return;
  var imgs = [].slice.call(z.querySelectorAll(':scope > img'));
  if (!imgs.length) return;
  var css = document.createElement('style');
  css.textContent = [
    '.zoom.is-open{display:block;overflow:hidden;z-index:1000;background:#fff}',
    '.zoom__track{display:flex;height:100%;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;overscroll-behavior:contain}',
    '.zoom__track::-webkit-scrollbar{display:none}',
    '.zoom.is-zoomed .zoom__track{overflow:hidden}',
    '.zoom__slide{flex:0 0 100%;height:100%;display:flex;align-items:center;justify-content:center;scroll-snap-align:start;overflow:hidden;touch-action:pan-x;cursor:zoom-in}',
    '.zoom.is-zoomed .zoom__slide{touch-action:none;cursor:zoom-out}',
    '.zoom .zoom__slide img{width:auto;height:auto;max-width:100%;max-height:100%;margin:0;transform-origin:center;will-change:transform;user-select:none;-webkit-user-drag:none}',
    '.zoom__count{position:fixed;left:50%;bottom:calc(18px + env(safe-area-inset-bottom));transform:translateX(-50%);margin:0;padding:6px 12px;background:rgba(255,255,255,.88);font-size:11px;letter-spacing:.16em}',
    '.zoom__close{z-index:2}'
  ].join('');
  document.head.appendChild(css);

  var track = document.createElement('div');
  track.className = 'zoom__track';
  imgs.forEach(function (img) {
    var f = document.createElement('div');
    f.className = 'zoom__slide';
    img.draggable = false;
    f.appendChild(img);
    track.appendChild(f);
  });
  var count = document.createElement('p');
  count.className = 'zoom__count';
  z.appendChild(track); z.appendChild(count);
  var slides = track.children, cur = 0, st = { s: 1, x: 0, y: 0 };
  var touchDevice = window.matchMedia('(hover: none)').matches;

  var img = function () { return slides[cur] && slides[cur].querySelector('img'); };
  var clamp = function () {
    var im = img(); if (!im) return;
    var r = im.parentNode.getBoundingClientRect();
    var mx = Math.max(0, (im.offsetWidth * st.s - r.width) / 2), my = Math.max(0, (im.offsetHeight * st.s - r.height) / 2);
    st.x = Math.max(-mx, Math.min(mx, st.x)); st.y = Math.max(-my, Math.min(my, st.y));
  };
  var paint = function (anim) {
    var im = img(); if (!im) return;
    im.style.transition = anim ? 'transform .3s ease' : 'none';
    im.style.transform = 'translate(' + st.x + 'px,' + st.y + 'px) scale(' + st.s + ')';
    z.classList.toggle('is-zoomed', st.s > 1.01);
  };
  var reset = function (anim) { st = { s: 1, x: 0, y: 0 }; paint(anim); };
  // Dokunulan/tıklanan nokta yerinde kalacak şekilde büyüt
  var zoomAt = function (px, py, s) {
    var r = slides[cur].getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    st.x = (px - cx - st.x) * (1 - s / st.s) + st.x; st.y = (py - cy - st.y) * (1 - s / st.s) + st.y; st.s = s;
    clamp(); paint(true);
  };
  var label = function () { count.textContent = (cur + 1) + ' / ' + slides.length; };
  track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i !== cur) { reset(false); cur = i; label(); }
  }, { passive: true });

  window.pd2Zoom = function (i) {
    z.classList.add('is-open'); document.body.classList.add('no-scroll');
    cur = Math.max(0, Math.min(slides.length - 1, i || 0));
    var im = img(); if (im && im.loading === 'lazy') im.loading = 'eager';
    track.scrollLeft = cur * track.clientWidth;
    reset(false); label();
  };
  var close = function () { reset(false); z.classList.remove('is-open', 'is-zoomed'); document.body.classList.remove('no-scroll'); };
  z.addEventListener('click', function (e) { if (e.target.closest('[data-modal-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!z.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
  });

  if (touchDevice) {
    var pinch = null, pan = null, lastTap = 0, tapX = 0, tapY = 0, moved = false;
    var dist = function (t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); };
    track.addEventListener('touchstart', function (e) {
      moved = false;
      if (e.touches.length === 2) {
        e.preventDefault();
        var m = { x: (e.touches[0].clientX + e.touches[1].clientX) / 2, y: (e.touches[0].clientY + e.touches[1].clientY) / 2 };
        pinch = { d: dist(e.touches), s: st.s, x: st.x, y: st.y, m: m };
        pan = null;
      } else if (e.touches.length === 1 && st.s > 1.01) {
        pan = { x: e.touches[0].clientX - st.x, y: e.touches[0].clientY - st.y };
      }
    }, { passive: false });
    track.addEventListener('touchmove', function (e) {
      moved = true;
      if (pinch && e.touches.length === 2) {
        e.preventDefault();
        var s = Math.max(1, Math.min(4, pinch.s * dist(e.touches) / pinch.d));
        var r = slides[cur].getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        st.s = s;
        st.x = pinch.m.x - cx - (pinch.m.x - cx - pinch.x) * (s / pinch.s);
        st.y = pinch.m.y - cy - (pinch.m.y - cy - pinch.y) * (s / pinch.s);
        clamp(); paint(false);
      } else if (pan && e.touches.length === 1) {
        e.preventDefault();
        st.x = e.touches[0].clientX - pan.x; st.y = e.touches[0].clientY - pan.y;
        clamp(); paint(false);
      }
    }, { passive: false });
    track.addEventListener('touchend', function (e) {
      if (pinch && e.touches.length < 2) { pinch = null; if (st.s < 1.05) reset(true); return; }
      if (e.touches.length) return;
      pan = null;
      var t = e.changedTouches[0], now = Date.now();
      if (!moved && now - lastTap < 300 && Math.abs(t.clientX - tapX) < 30 && Math.abs(t.clientY - tapY) < 30) {
        if (st.s > 1.01) reset(true); else zoomAt(t.clientX, t.clientY, 2.5);
        lastTap = 0;
      } else if (!moved) { lastTap = now; tapX = t.clientX; tapY = t.clientY; }
    });
  } else {
    track.addEventListener('click', function (e) {
      if (!e.target.closest('.zoom__slide')) return;
      if (st.s > 1.01) reset(true); else zoomAt(e.clientX, e.clientY, 2.5);
    });
    track.addEventListener('mousemove', function (e) {
      if (st.s <= 1.01) return;
      var im = img(), r = slides[cur].getBoundingClientRect();
      var mx = Math.max(0, (im.offsetWidth * st.s - r.width) / 2), my = Math.max(0, (im.offsetHeight * st.s - r.height) / 2);
      st.x = -((e.clientX - r.left) / r.width * 2 - 1) * mx;
      st.y = -((e.clientY - r.top) / r.height * 2 - 1) * my;
      paint(false);
    });
  }
})();
